module.exports = __webpack_public_path__ + "media/images/vp/bg.heart.red-350fb7a838d2635d8b2212cbb1ab0e35.png";